const getDefaultState = () => {
    return {
        items: [],
    }
};

const state = getDefaultState();

const getters = {
};

const actions = {
};

const mutations = {
    set(state, payload) {
        state.items = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
